// extracted by mini-css-extract-plugin
export var borderRadius = "_gn-4";
export var large = "_gn-3";
export var logoContainer = "_gn-0";
export var nameLogo = "_gn-2";
export var small = "_gn-1";